module.exports = __webpack_public_path__ + "static/img/9.bd2576e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/9.png
// module id = rLZ4
// module chunks = 0